import React from 'react';
import HandwrittenName from './HandwrittenName';

/**
 * The top of the page: the name, written. Nothing else above the tagline, so
 * the handwriting carries the header on its own.
 *
 * The name is the page's <h1>. The drawing itself is aria-hidden and the
 * accessible name comes from the screen-reader-only span inside
 * HandwrittenName, so the heading reads as "Kazuya Hirotsu" whether or not the
 * ink ever arrives.
 */
export default function Hero({ hand = 'PacificoSLO', t }) {
  return (
    <header className="hero">
      <h1 className="written-name">
        <HandwrittenName font={hand} />
      </h1>
      <p className="place">{t.ui.place}</p>
      <p className="lede">{t.hero.tagline}</p>
    </header>
  );
}
